const resources = {
    pageTitle: 'Autoriser l’accès à votre compte Beauty Insider',
    whatCanDo: 'Ce que ChatGPT peut faire',
    permission1: 'Recommander des produits que vous adorerez',
    permission2: 'Trouver et magasiner vos favoris plus rapidement',
    permission3: 'Découvrir les marques et les rituels qui vous conviennent',
    allowAccessButton: 'Autoriser l’accès',
    cancelButton: 'Annuler',
    manageAccessText: 'Vérifiez ou supprimez l’accès en tout temps dans vos paramètres ChatGPT en vous déconnectant de l’appli Sephora.',
    privacyPrefix: 'Pour plus de détails sur l’utilisation de vos données par ChatGPT, consultez la',
    chatGPTPrivacyPolicy: 'politique de confidentialité de ChatGPT',
    privacyMiddle: '. Pour savoir comment Sephora protège vos renseignements, consultez la',
    sephoraPrivacyPolicy: 'politique de confidentialité de Sephora,',
    privacyEnd: '.',
    sessionIdNotFound: 'Session ID not found. Please restart the authorization flow.',
    authorizationFailed: 'Authorization failed. Please try again.'
};

export default function getResource(label) {
    return resources[label];
}
